// console.log(process.env);
const firebaseConfig = {
    apiKey: "AIzaSyA0txJnTuby6TJDvxdq_1VaAXYcuZQ0Pak",
    authDomain: "bd-go-f9119.firebaseapp.com",
    projectId: "bd-go-f9119",
    storageBucket: "bd-go-f9119.appspot.com",
    messagingSenderId: "390803479370",
    appId: "1:390803479370:web:83e91e4cc803a286c0bfb3"
};

export default firebaseConfig;

    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID,